@if (systemLayoutService.isReady()) {
    <adaa-period-slider [activePeriod]="selectedPeriod()!" [frequency]="frequency" type="quarter" (periodSelect)="selectPeriod($event)" />
}
@let period = selectedPeriod();
@if (period) {
    <adaa-aggregated-performance *adaaHasPermission="overallPerformancePermission" [selectedPeriod]="period" [isPmo]="true">
        @if (hasKPIsWithIssue()) {
            <i
                class="fa fa-warning text-warning pointer"
                routerLink="/console/kpi/audit-issues"
                [title]="'landingPage.entity_page.kpi_issues' | translate"
            ></i>
        }
        {{ "landingPage.entity_page.government_overall_performance" | translate }}
        <b>{{ selectedPeriod()?.type === "year" ? "" : "Q" + period.period.quarter }} {{ period.period.year }}</b>
    </adaa-aggregated-performance>

    @if (isDsV2orV3()) {
        <adaa-uae-vision-performance *adaaHasPermission="weTheUaePermission" [selectedPeriod]="period" />
    } @else {
        @let periodId = period.type === "year" ? period.period.year : period.period.id;

        <adaa-gov-vision-performance [id]="periodId" [period]="period.period.id" [isAnnual]="period.type === 'year'" [selectedPeriod]="period" />
    }

    <adaa-ai-performance [selectedPeriod]="period" *adaaHasPermission="aiKpiPermission" />

    <adaa-gov-enabler-performance *adaaHasPermission="enablerPermission" [selectedPeriod]="period" />

    <adaa-national-strategies-performance *adaaHasPermission="nationalStrategiesPermission" [selectedPeriod]="period" />
}
